import { render, staticRenderFns } from "./RealEstateViewModal.vue?vue&type=template&id=6bba7078&"
import script from "./RealEstateViewModal.vue?vue&type=script&lang=js&"
export * from "./RealEstateViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports